import { keyframes } from "tss-react"
import { makeStyles } from "tss-react/mui"

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const useStyles = makeStyles()(() => ({
  circleLoader: {
    animation: `${rotate} 2s infinite linear`
  }
}))
